import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AnimationOptions } from 'ngx-lottie';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-version-checker',
  templateUrl: './version-checker.component.html',
  styleUrls: ['./version-checker.component.scss'],
})
export class VersionCheckerComponent implements OnInit {
  version = environment.version;
  
  lottieConfig: AnimationOptions = {
    path: 'assets/lottie/update.json', // Animasyon dosyasının yolu
  };

  constructor(
    private modalController: ModalController,
    private dataServ: DataService
  ) {}

  ngOnInit() {}

  closeModal() {
    this.modalController.dismiss();
  }

  redirectToStore() {
    if (this.dataServ.rData) {
      window.open(
        'https://api.icibot.net/h/' + this.dataServ.rData.id,
        '_system'
      );
    }
  }
}
